'use client';

import { useEffect } from 'react';
import ErrorCard from '../components/ui/ErrorCard';

// FIX-38: segment-level error boundary for the search page.
export default function SearchError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Search route error:', error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: '#020617' }}>
      <ErrorCard
        title="Search hit an error"
        message="Something went wrong running that search. Try again."
        onRetry={reset}
      />
    </div>
  );
}
